import { EventCustomAttributes } from 'utils/analytics/eventTypeConstantsAmplitude';
import { Typography } from 'omakase';
import { consumer } from '@tock/coretypes';
import Anchor from 'components/Anchor';

type ClickContext = EventCustomAttributes['clickContext'];

interface OfferingHeadingProps {
  isShowingOnBusinessPage?: boolean;
  navigate: boolean;
  linkTo?: string;
  label?: string;
  offering: consumer.Offering;
  onNavigateToExperience?(event: consumer.Offering, nextAvailableDate?: string): void;
  onClick?(): void;
  onClickTarget: (context: ClickContext) => void;
  dataTestIdValue: string;
}

const OfferingHeadingTypography: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Typography
    className="Consumer-reservationHeading"
    component="h3"
    variant="heading03"
    data-testid="experience-name"
  >
    {children}
  </Typography>
);

const OfferingHeading: React.FC<OfferingHeadingProps> = ({
  isShowingOnBusinessPage,
  navigate,
  linkTo,
  label,
  offering,
  onNavigateToExperience,
  onClick,
  onClickTarget,
  dataTestIdValue,
}) => {
  const { name } = offering;

  const opensModal = navigate && !linkTo;
  const isStatic = !navigate && !linkTo;
  const isLink = !navigate && linkTo;

  return isShowingOnBusinessPage ? (
    <>
      {opensModal && (
        <button
          aria-label={label}
          onClick={() => {
            onNavigateToExperience?.(offering);
            onClickTarget('Title');
          }}
          className="Consumer-reservationLink"
        >
          <OfferingHeadingTypography>{name}</OfferingHeadingTypography>
        </button>
      )}
      {isStatic && <OfferingHeadingTypography>{name}</OfferingHeadingTypography>}
      {isLink && (
        <OfferingHeadingTypography>
          <Anchor
            data-testid={`offering-link_${dataTestIdValue}`}
            onClick={() => {
              onClick && onClick();
              onClickTarget('Title');
            }}
            aria-label={label}
            className="Consumer-reservationLink"
            href={linkTo}
          >
            {name}
          </Anchor>
        </OfferingHeadingTypography>
      )}
    </>
  ) : (
    <>
      {navigate && (
        <button
          aria-label={`View ${name} (opens a dialog)`}
          onClick={() => onNavigateToExperience?.(offering)}
          className="Consumer-reservationLink"
        >
          <OfferingHeadingTypography>{name}</OfferingHeadingTypography>
        </button>
      )}
      {!navigate && <OfferingHeadingTypography>{name}</OfferingHeadingTypography>}
    </>
  );
};

export default OfferingHeading;
